<template>
    <div>
        <div class="Fixed">
            <el-tooltip placement="left">
                <div slot="content" class="experience">
                    <p class="head">
                        <img class="qrcode" :src="require('@/assets/images/fixed/小程序码.jpg')" width="125px"
                            height="125px" alt="">
                    </p>
                    <div class="body">扫码体验微信小程序</div>
                </div>
                <div class="item flex-column">
                    <img class="unhover" :src="require('@/assets/images/fixed/二维码.png')" width="18px" height="18px"
                        alt="">
                    <img class="hover" :src="require('@/assets/images/fixed/二维码-hover.png')" width="18px" height="18px"
                        alt="">
                    <span class="text">扫码体验</span>
                </div>
            </el-tooltip>
            <el-tooltip placement="left">
                <div slot="content" class="connect">
                    <a href="tel:13924583058" class="phone-link">
                        <p class="head">立即联系我们</p>
                        <p class="body">13924583058</p>
                    </a>

                </div>
                <div class="item flex-column">
                    <img class="unhover" :src="require('@/assets/images/fixed/电话.png')" width="18px" height="18px"
                        alt="">
                    <img class="hover" :src="require('@/assets/images/fixed/电话-hover.png')" width="18px" height="18px"
                        alt="">
                    <span class="text">电话热线</span>
                </div>
            </el-tooltip>
            <el-popover placement="left" trigger="hover">
                <!-- 弹出内容 -->
                <div class="scheduleDemo" @click.stop>
                    <div class="head">
                        <div class="title">咨询登记</div>
                        <div class="sub-title">提交后2个工作日内将有专人联系，请保持手机畅通</div>
                    </div>
                    <div class="body">
                        <el-form label-position="top" label-width="80px" :model="formData" :rules="rules" ref="formRef">
                            <el-form-item label="您的姓名" prop="name">
                                <el-input v-model="formData.name"></el-input>
                            </el-form-item>
                            <el-form-item label="您的手机号码" prop="phone">
                                <el-input v-model="formData.phone"></el-input>
                            </el-form-item>
                            <el-form-item label="您的公司名称" prop="company">
                                <el-input v-model="formData.company"></el-input>
                            </el-form-item>
                            <el-form-item label="您在公司的职位" prop="jobTitle">
                                <el-input v-model="formData.jobTitle"></el-input>
                            </el-form-item>
                            <el-form-item label="您希望了解的内容" prop="content">
                                <el-input v-model="formData.content" type="textarea"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button class="submitBtn" type="primary"
                                    @click="submitForm('formRef')">立即登记</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>

                <!-- 触发按钮区域 -->
                <div slot="reference" class="item flex-column">
                    <img class="unhover" :src="require('@/assets/images/fixed/演示图表.png')" width="18px" height="18px"
                        alt="">
                    <img class="hover" :src="require('@/assets/images/fixed/演示图表-hover.png')" width="18px" height="18px"
                        alt="">
                    <span class="text">预约演示</span>
                </div>
            </el-popover>

        </div>
        <el-backtop class="hide-in-mobile" :right="55" :bottom="140" />
        <el-backtop class="hide-in-pc" :right="25" :bottom="140" />
    </div>

</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            formData: {
                name: "",
                phone: "",
                company: "",
                jobTitle: "",
                content: ""
            },
            rules: {
                name: [
                    { required: true, message: '请输入您的姓名', trigger: 'blur' },
                ],

                phone: [
                    { required: true, message: '请输入您的电话号码', trigger: 'blur' },
                    { pattern: /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1589]))\d{8}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                company: [
                    { required: true, message: '请输入您的公司名称', trigger: 'blur' },
                ],
                content: [
                    { required: true, message: '请输入您希望了解的内容', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log(JSON.stringify(this.formData), 'formData===')
                    this.submitFn(this.formData)
                    // alert(JSON.stringify(this.formData));

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        submitFn(data) {
            // 发送 GET 请求
            this.$axios.post(`${process.env.VUE_APP_BASE_API}/consultation/insert`, data)
                .then(response => {
                    console.log(response.data, '请求响应结果===')
                    if (response.data.code === 200) {
                        this.$message({
                            message: '登记成功,我们会尽快与您联系',
                            type: 'success'
                        });
                        this.$refs.formRef.resetFields()
                    }
                })
                .catch(error => {
                    console.error('请求出错：', error)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.Fixed {
    width: 60px;
    border-radius: 5px;
    position: fixed;
    right: 46px;
    bottom: 200px;
    background: #FEFFFF;
    box-shadow: 0px 3px 4px 0px rgba(112, 130, 235, 0.17);
    z-index: 99;

    .item {
        height: 65px;
        border-radius: 4px;
        font-size: 12px;
        color: #152646;
        cursor: pointer;
        user-select: none;

        .unhover {
            display: block;
        }

        .hover {
            display: none;
        }

        .text {
            margin-top: 6px;
        }

        &:hover {
            color: #fff;
            background-color: #0d68ff;

            .unhover {
                display: none;
            }

            .hover {
                display: block;
            }
        }
    }

    .flex-column {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}

.experience {
    .head {
        margin-bottom: 6px;
    }

    .body {
        text-align: center;
        font-size: 12px;
    }
}

.connect {
    .head {
        margin-bottom: 6px;
        font-size: 14px;
    }

    .body {
        font-size: 18px;
    }
}

.scheduleDemo {
    padding: 15px 15px;
    width: 500px;
    // height: 670px;

    .head {
        text-align: center;

        .title {
            margin-bottom: 6px;
            font-size: 26px;
        }
    }

    .submitBtn {
        width: 100%;
    }
}

.hide-in-pc {
    display: none;
}

.hide-in-mobile {
    display: flex;
}

@media screen and (max-width: 980px) {
    .Fixed {
        width: 60px;
        border-radius: 5px;
        position: fixed;
        right: 15px;
        bottom: 200px;
        background: #FEFFFF;
        box-shadow: 0px 3px 4px 0px rgba(112, 130, 235, 0.17);
        z-index: 99;

        .item {
            height: 65px;
            border-radius: 4px;
            font-size: 12px;
            color: #152646;
            cursor: pointer;
            user-select: none;

            .unhover {
                display: block;
            }

            .hover {
                display: none;
            }

            .text {
                margin-top: 6px;
            }

            &:hover {
                color: #fff;
                background-color: #0d68ff;

                .unhover {
                    display: none;
                }

                .hover {
                    display: block;
                }
            }
        }

        .flex-column {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
    }

    .experience {
        .head {
            margin-bottom: 6px;
        }

        .body {
            text-align: center;
            font-size: 12px;
        }
    }

    .connect {
        .head {
            margin-bottom: 6px;
            font-size: 14px;
        }

        .body {
            font-size: 18px;
        }
    }

    .scheduleDemo {
        padding: 15px 10px 0;
        width: 275px;
        // height: 670px;

        .head {
            text-align: center;

            .title {
                margin-bottom: 6px;
                font-size: 20px;
            }
        }

        .submitBtn {
            width: 100%;
        }

        ::v-deep(.el-form-item__label) {
            padding-bottom: 6px;
        }

        ::v-deep(.el-form-item) {
            margin-bottom: 6px;
        }
    }

    .hide-in-pc {
        display: flex;
    }

    .hide-in-mobile {
        display: none;
    }
}
</style>
